import { PlanUiId } from '../models/payment-plan.model';

export interface HouseholdPlanConfig {
  id: PlanUiId;
  titleKey: string;
  priceLabelKey: string;
  intervalNoteKey: string;
}

/**
 * Card chrome (titles / fallback price labels). Feature bullets come from
 * GET /payments/plans → limits.
 */
export const HOUSEHOLD_PLAN_CONFIGS: HouseholdPlanConfig[] = [
  {
    id: 'base',
    titleKey: 'app.components.upgradePlan.plans.base.title',
    priceLabelKey: 'app.components.upgradePlan.plans.base.priceLabel',
    intervalNoteKey: 'app.components.upgradePlan.plans.base.intervalNote',
  },
  {
    id: 'care',
    titleKey: 'app.components.upgradePlan.plans.care.title',
    priceLabelKey: 'app.components.upgradePlan.plans.care.priceLabel',
    intervalNoteKey: 'app.components.upgradePlan.plans.care.intervalNote',
  },
  {
    id: 'family',
    titleKey: 'app.components.upgradePlan.plans.family.title',
    priceLabelKey: 'app.components.upgradePlan.plans.family.priceLabel',
    intervalNoteKey: 'app.components.upgradePlan.plans.family.intervalNote',
  },
];
